import { io } from 'socket.io-client';

// The backend only accepts logged-in support staff, so the login token is
// sent on every (re)connect. `auth` is a function so it always reads the
// latest token (e.g. right after login).
//
// autoConnect is OFF: this file is part of the main bundle, so connecting on
// import would open a (rejected) websocket for every website visitor.
// Support screens call connectSocket() when they mount.
const socket = io(process.env.REACT_APP_BASE_URL, {
    transports: ['websocket'],
    autoConnect: false,
    auth: (cb) => cb({ token: localStorage.getItem('supToken') })
});

export const connectSocket = () => {
    if (!socket.connected && localStorage.getItem('supToken')) socket.connect();
};

// If the server rejects the connection (expired token / server restart),
// Socket.IO does not retry by itself — retry every few seconds while a
// support token exists. Normal users never get here.
socket.on('connect_error', (err) => {
    console.log('Socket connect error:', err.message);
    setTimeout(connectSocket, 3000);
});

export default socket;
